module.exports = __webpack_public_path__ + "static/img/empty.da3c9722.png";